// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af01f7f5","239":"16396383","453":"12c92154","455":"3306c27a"}[chunkId] + ".chunk.js";
};